import axiosInstance from "../axiosInstance";

export const getUser = async () => {
  try {
    const response = await axiosInstance.get("user/");
    return response.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const getSingleUser = async () => {
  try {
    const response = await axiosInstance.get("user/");
    return response?.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const getExperience = async () => {
  try {
    const response = await axiosInstance.get("experience/");
    return response?.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const updateUser = async (body: any) => {
  try {
    const response = await axiosInstance.put("user/info", body);
    const data = await axiosInstance.put('/user',body);
    return response?.data?.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const pauseUserAccount = async (body: any) => {
  try {
    const response = await axiosInstance.put("user/deactivate", body);
    return response?.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const deleteUserAccount = async (body: any) => {
  try {
    const response = await axiosInstance.post("user/delete", body);
    return response?.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const getSingleExprience = async (
  exprienceId: string,
) => {
  try {
    const response = await axiosInstance.get(
      `experience/${exprienceId}`,
    );
    // console.log(response?.data);
    return response?.data?.experience;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const getS3URL = async (body: any) => {
  // console.log(body)
  try {
    const response = await axiosInstance.post(
      "document/generate-upload-s3-link",
      body,
    );
    return response?.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

const getBlob = async (fileUri: any) => {
  const resp = await fetch(fileUri);
  const imageBody = await resp.blob();
  return imageBody;
};

// export const putImageInS3URL = async (url: String, body: any) => {
//   const fromData = new FormData();
//   let filepath = body.imageURL;
//   const imageBody = await getBlob(filepath);
//   const uploadUrl = url;
//   console.log(uploadUrl);
//   const resData = await fetch(url, {
//     method: "PUT",
//     body: imageBody,
//   });
//   return resData;
// };

export const putImageInS3URL = async (url: string, body: any) => {
  const fromData = new FormData();
  let filepath = body.imageURL;
  const imageBody = await getBlob(filepath);

  const uploadUrl = url;
  // console.log(uploadUrl);
  const resData = await fetch(url, {
    method: "PUT",
    body: imageBody,
  });
  return resData;
};

export const getImageURL = async (body: any) => {
  try {
    const response = await axiosInstance.post("document/get-view-media-link", body);
    return response?.data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const getCity = async (latitude: any, longitude: any) => {
  try {
    const response = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${latitude}%2C${longitude}&key=c69dadf93b3e467eaaf14491f51e2b34`
    );
    return response.json();
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const convertIntoEnglish = async (fromText: any, fromLanguage: any) => {
  try {
    const response = await fetch(
      `https://api.mymemory.translated.net/get?q=${fromText}&langpair=${fromLanguage}%7Cen`
    );
    return response.json();
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};
